import React from 'react';
import {SPAN_HALF} from "../../../styles/constants";
import {Form, Modal} from "antd";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {readELCategories, setELCategory} from "../actions";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import Call from "../../../hocs/call";
import EnhancedTree from "../../enhanced-tree";
import {getNode} from "../../../utils/tree";
import {DCS_ORDERED_TREE_ROOT} from "../../../utils/treeBuilders";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  agencies: state.scenes.easyLoading.agencies,
  categoryTree: state.scenes.easyLoading.categoryTree,
  forbiddenCategoriesCodes: state.scenes.easyLoading.forbiddenCategoriesCodes,
  category: state.scenes.easyLoading.category
});

const mapDispatchToProps = dispatch => ({
  fetchCategories: () => dispatch(readELCategories()),
  onCategorySet: category => dispatch(setELCategory(category))
});

const ELCategoryTree = ({
                          t,
                          appLanguage,
                          dataLanguages,
                          categoryTree,
                          category,
                          forbiddenCategoriesCodes,
                          fetchCategories,
                          onCategorySet
                        }) =>
  <div className="el__cubes-tree">
    <Call
      cb={fetchCategories}
      disabled={categoryTree !== null}
    >
      <Form.Item
        className="form-item-required"
        label={t('components.easyLoading.steps.data.body.categoryTree.label')}
        style={{marginBottom: 0}}
      />
      <EnhancedTree
        tree={categoryTree}
        childrenKey="children"
        idKey="Code"
        nameKey="labels"
        catIdKey="CatCode"
        catNameKey="labels"
        hiddenIdKeys={[DCS_ORDERED_TREE_ROOT.CatCode]}
        unselectableKeys={[DCS_ORDERED_TREE_ROOT.CatCode]}
        defaultSelectedKeys={category !== null ? [category.CatCode] : null}
        getFilter={
          searchText =>
            ({CatCode, labels}) => {
              const search = searchText.toLowerCase();
              return (CatCode && CatCode.toLowerCase()
                  .indexOf(search) >= 0) ||
                getLocalizedStr(labels, appLanguage, dataLanguages)
                  .toLowerCase()
                  .indexOf(search) >= 0;
            }
        }
        unallowedIdKeys={forbiddenCategoriesCodes}
        onSelect={
          selectedArr => {
            if (selectedArr !== null && selectedArr.length > 0) {
              const node = getNode(
                categoryTree,
                'children',
                node => node.children
                  ? node.CatCode === selectedArr[0]
                  : node.Code === selectedArr[0]
              );
              onCategorySet({
                ...node,
                CatCode: node.CatCode !== DCS_ORDERED_TREE_ROOT.CatCode ? node.CatCode : null
              });
              if (node.CatCode !== DCS_ORDERED_TREE_ROOT.CatCode &&
                forbiddenCategoriesCodes.includes(node.CatCode)
              ) {
                Modal.error({
                  title: t('components.easyLoading.steps.data.body.categoryTree.modals.forbiddenCategory.title'),
                  content: t('components.easyLoading.steps.data.body.categoryTree.modals.forbiddenCategory.content')
                })
              }
            } else {
              onCategorySet(null);
            }
          }
        }
        treeActions={[
          {
            title: t('components.easyLoading.steps.data.body.categoryTree.refreshButton.title'),
            icon: 'sync',
            onClick: fetchCategories
          }
        ]}
        icon="cube"
        isCustomIcon
        getIconColor={() => "#37a0f4"}
        searchBarSpan={SPAN_HALF}
      />
    </Call>
  </div>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(ELCategoryTree);


// WEBPACK FOOTER //
// ./src/components/easy-loading/data-step/CategoryTree.jsx